/*  global Rayban */
(function (Rayban) {
  'use strict';

  var VERSION = '1.0',
    RBTabs = function (trigger, settings) {
      if (settings) {
        this.settings = Rayban.utilities.extend(this.settings, settings);
      }

      this.trigger = trigger;
      this.selectors = this.trigger.querySelectorAll(this.settings.tabSelectorsQuery);
      this.tabs = this.trigger.querySelectorAll(this.settings.tabsQuery);
      this.init();
    };

  RBTabs.prototype = {
    version: VERSION,
    settings: {
      tabsQuery: '.rb-tab',
      tabSelectorsQuery: '.rb-tab-selector',
      activeClass: 'active',
      tabRetriever: function (trigger) {
        return document.getElementById(trigger.getAttribute('rel'))
      },
      onShowTab: function (tab) {}
    },

    init: function () {
      var self = this, i, el;
      if (self.selectors && self.selectors.length) {
        for (i = 0; i < self.selectors.length; i += 1) {
          el = self.selectors[i];
          el.addEventListener('click', function(e) {
            var targetTab = self.settings.tabRetriever(e.target);
            if (targetTab) {
              self.showTab(e.target, targetTab);
            }
          }, false);
        }
      }

    },

    showTab: function(trigger, target) {
      var self = this, i;
      if (self.selectors && self.selectors.length) {
        for (i = 0; i < self.selectors.length; i += 1) {
          self.selectors[i].classList.remove(self.settings.activeClass);
          Rayban.utilities.getClosest(self.selectors[i], '.rb-radio').classList.remove(self.settings.activeClass);
        }
      }
      trigger.classList.add(self.settings.activeClass);
      Rayban.utilities.getClosest(trigger, '.rb-radio').classList.add(self.settings.activeClass);

      if (self.tabs && self.tabs.length) {
        for (i = 0; i < self.tabs.length; i += 1) {
          self.tabs[i].classList.remove(self.settings.activeClass);
        }
      }
      target.classList.add(self.settings.activeClass);
      self.settings.onShowTab(target);
    }
  };

  Rayban.RBTabs = function (trigger, settings) {
    var tabs = new RBTabs(trigger, settings);
    trigger.RBTabs = tabs;
  };

})(window.Rayban = window.Rayban || {});
